<template>
  <a-drawer
    v-if="drawer"
    :visible="open"
    width="92%"
    :destroyOnClose="true"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ $t('views.specOption.drawerTitle') }}</b>
    </a-divider>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col v-if="!drawer" :md="8" :sm="24">
              <a-form-item :label="$t('views.specOption.query.specId')" prop="specId">
                <a-input v-model="queryParam.specId" :placeholder="$t('views.specOption.query.specIdPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.specOption.query.name')" prop="name">
                <a-input v-model="queryParam.name" :placeholder="$t('views.specOption.query.namePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.parentId')" prop="parentId">
                  <a-input v-model="queryParam.parentId" :placeholder="$t('views.specOption.query.parentIdPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isCalculation')" prop="isCalculation">
                  <a-input v-model="queryParam.isCalculation" :placeholder="$t('views.specOption.query.isCalculationPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isRequired')" prop="isRequired">
                  <a-input v-model="queryParam.isRequired" :placeholder="$t('views.specOption.query.isRequiredPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isConflict')" prop="isConflict">
                  <a-input v-model="queryParam.isConflict" :placeholder="$t('views.specOption.query.isConflictPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isCustomization')" prop="isCustomization">
                  <a-input v-model="queryParam.isCustomization" :placeholder="$t('views.specOption.query.isCustomizationPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.identityRestrictions')" prop="identityRestrictions">
                  <a-input v-model="queryParam.identityRestrictions" :placeholder="$t('views.specOption.query.identityRestrictionsPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isPrompt')" prop="isPrompt">
                  <a-input v-model="queryParam.isPrompt" :placeholder="$t('views.specOption.query.isPromptPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.defaultOption')" prop="defaultOption">
                  <a-input v-model="queryParam.defaultOption" :placeholder="$t('views.specOption.query.defaultOptionPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.sellingPrice')" prop="sellingPrice">
                  <a-input v-model="queryParam.sellingPrice" :placeholder="$t('views.specOption.query.sellingPricePlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.costPrice')" prop="costPrice">
                  <a-input v-model="queryParam.costPrice" :placeholder="$t('views.specOption.query.costPricePlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.materialDensity')" prop="materialDensity">
                  <a-input v-model="queryParam.materialDensity" :placeholder="$t('views.specOption.query.materialDensityPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.membraneWidth')" prop="membraneWidth">
                  <a-input v-model="queryParam.membraneWidth" :placeholder="$t('views.specOption.query.membraneWidthPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isThickness')" prop="isThickness">
                  <a-input v-model="queryParam.isThickness" :placeholder="$t('views.specOption.query.isThicknessPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.materialThickness')" prop="materialThickness">
                  <a-input v-model="queryParam.materialThickness" :placeholder="$t('views.specOption.query.materialThicknessPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.url')" prop="url">
                  <a-input v-model="queryParam.url" :placeholder="$t('views.specOption.query.urlPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.sort')" prop="sort">
                  <a-input v-model="queryParam.sort" :placeholder="$t('views.specOption.query.sortPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.specOption.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.specOption.btn.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()"  v-if="!isSimpleSpec">
          <a-icon type="plus" />{{ $t('views.specOption.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-if="!isSimpleSpec" >
          <a-icon type="edit" />{{ $t('views.specOption.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-if="!isSimpleSpec">
          <a-icon type="delete" />{{ $t('views.specOption.btn.delete') }}
        </a-button>
<!--        <table-setting-->
<!--          :style="{float: 'right'}"-->
<!--          :table-size.sync="tableSize"-->
<!--          v-model="columns"-->
<!--          :refresh-loading="loading"-->
<!--          @refresh="getList" />-->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :drawer="drawer"
        :fixed-spec-id="queryParam.specId"
        :simple-mode="isSimpleSpec"
        :show-calc="showCalc"
        :show-density="showDensity"
        :show-manuscript-fee="showManuscriptFee"
        :spec-is-calculation="specIsCalculation"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="displayColumns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="isConflict" slot-scope="text, record">
          {{ formatYesNo(record.isConflict) }}
        </span>
        <span slot="isPrompt" slot-scope="text, record">
          {{ formatPrompt(record.isPrompt) }}
        </span>
        <span slot="isThickness" slot-scope="text, record">
          {{ formatYesNo(record.isThickness) }}
        </span>
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            :disabled="!canEdit"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            :disabled="!canEdit"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <template v-if="isSimpleSpec">
            <a-divider type="vertical" />
            <a v-if="canEdit" @click="$refs.createForm.handleUpdate(record, undefined)">
              <a-icon type="edit" />{{ $t('views.specOption.btn.edit') }}
            </a>
            <span v-else style="color: rgba(0,0,0,.45)">
              <a-icon type="eye" />{{ $t('views.specOption.btn.view') }}
            </span>
          </template>
          <template v-else>
            <template v-if="canEdit">
              <a-divider type="vertical" />
              <a @click="$refs.createForm.handleUpdate(record, undefined)">
                <a-icon type="edit" />{{ $t('views.specOption.btn.edit') }}
              </a>
            </template>
            <template v-else>
              <a-divider type="vertical" />
              <span style="color: rgba(0,0,0,.45)">
                <a-icon type="eye" />{{ $t('views.specOption.btn.view') }}
              </span>
            </template>
            <a-divider type="vertical" v-hasPermi="['user:specOption:remove']" />
            <a @click="handleDelete(record)" v-hasPermi="['user:specOption:remove']">
              <a-icon type="delete" />{{ $t('views.specOption.btn.delete') }}
            </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-drawer>

  <page-header-wrapper v-else>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.specOption.query.specId')" prop="specId">
                <a-input v-model="queryParam.specId" :placeholder="$t('views.specOption.query.specIdPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.specOption.query.name')" prop="name">
                <a-input v-model="queryParam.name" :placeholder="$t('views.specOption.query.namePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.parentId')" prop="parentId">
                  <a-input v-model="queryParam.parentId" :placeholder="$t('views.specOption.query.parentIdPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isCalculation')" prop="isCalculation">
                  <a-input v-model="queryParam.isCalculation" :placeholder="$t('views.specOption.query.isCalculationPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isRequired')" prop="isRequired">
                  <a-input v-model="queryParam.isRequired" :placeholder="$t('views.specOption.query.isRequiredPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isConflict')" prop="isConflict">
                  <a-input v-model="queryParam.isConflict" :placeholder="$t('views.specOption.query.isConflictPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isCustomization')" prop="isCustomization">
                  <a-input v-model="queryParam.isCustomization" :placeholder="$t('views.specOption.query.isCustomizationPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.identityRestrictions')" prop="identityRestrictions">
                  <a-input v-model="queryParam.identityRestrictions" :placeholder="$t('views.specOption.query.identityRestrictionsPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isPrompt')" prop="isPrompt">
                  <a-input v-model="queryParam.isPrompt" :placeholder="$t('views.specOption.query.isPromptPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.defaultOption')" prop="defaultOption">
                  <a-input v-model="queryParam.defaultOption" :placeholder="$t('views.specOption.query.defaultOptionPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.sellingPrice')" prop="sellingPrice">
                  <a-input v-model="queryParam.sellingPrice" :placeholder="$t('views.specOption.query.sellingPricePlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.costPrice')" prop="costPrice">
                  <a-input v-model="queryParam.costPrice" :placeholder="$t('views.specOption.query.costPricePlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.materialDensity')" prop="materialDensity">
                  <a-input v-model="queryParam.materialDensity" :placeholder="$t('views.specOption.query.materialDensityPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.membraneWidth')" prop="membraneWidth">
                  <a-input v-model="queryParam.membraneWidth" :placeholder="$t('views.specOption.query.membraneWidthPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.isThickness')" prop="isThickness">
                  <a-input v-model="queryParam.isThickness" :placeholder="$t('views.specOption.query.isThicknessPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.materialThickness')" prop="materialThickness">
                  <a-input v-model="queryParam.materialThickness" :placeholder="$t('views.specOption.query.materialThicknessPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.url')" prop="url">
                  <a-input v-model="queryParam.url" :placeholder="$t('views.specOption.query.urlPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.specOption.query.sort')" prop="sort">
                  <a-input v-model="queryParam.sort" :placeholder="$t('views.specOption.query.sortPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.specOption.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.specOption.btn.reset') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('views.specOption.collapse') : $t('views.specOption.expand') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:specOption:add']">
          <a-icon type="plus" />{{ $t('views.specOption.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:specOption:edit']">
          <a-icon type="edit" />{{ $t('views.specOption.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:specOption:remove']">
          <a-icon type="delete" />{{ $t('views.specOption.btn.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改（与抽屉内表单一致传入主规格元数据，保证 isCalculation 同步） -->
      <create-form
        ref="createForm"
        :drawer="false"
        :fixed-spec-id="queryParam.specId"
        :simple-mode="isSimpleSpec"
        :show-calc="showCalc"
        :show-density="showDensity"
        :show-manuscript-fee="showManuscriptFee"
        :spec-is-calculation="specIsCalculation"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="displayColumns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            :disabled="!canEdit"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            :disabled="!canEdit"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <template v-if="isSimpleSpec">
            <a-divider type="vertical" />
            <a v-if="canEdit" @click="$refs.createForm.handleUpdate(record, undefined)">
              <a-icon type="edit" />{{ $t('views.specOption.btn.edit') }}
            </a>
            <span v-else style="color: rgba(0,0,0,.45)">
              <a-icon type="eye" />{{ $t('views.specOption.btn.view') }}
            </span>
          </template>
          <template v-else>
            <template v-if="canEdit">
              <a-divider type="vertical" />
              <a @click="$refs.createForm.handleUpdate(record, undefined)">
                <a-icon type="edit" />{{ $t('views.specOption.btn.edit') }}
              </a>
            </template>
            <template v-else>
              <a-divider type="vertical" />
              <span style="color: rgba(0,0,0,.45)">
                <a-icon type="eye" />{{ $t('views.specOption.btn.view') }}
              </span>
            </template>
            <a-divider type="vertical" v-hasPermi="['user:specOption:remove']" />
            <a @click="handleDelete(record)" v-hasPermi="['user:specOption:remove']">
              <a-icon type="delete" />{{ $t('views.specOption.btn.delete') }}
            </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSpecOption,listSpecOption, delSpecOption, updateSpecOption, updateSpecOptionSort, updateSpecOptionStatus } from '@/api/user/specOption'
import { getSpec } from '@/api/user/spec'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import auth from '@/plugins/auth'

export default {
  name: 'SpecOption',
  props: {
    drawer: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      open: false,
      showCalc: false,
      showDensity: false,
      /** 印刷效果规格：展示/编辑图稿费用(manuscript_fee) */
      showManuscriptFee: false,
      /** 当前所属规格「是否参与计算」，与选项子表 isCalculation 保持一致 */
      specIsCalculation: 0,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        specId: null,
        name: null,
        parentId: null,
        isCalculation: null,
        type: null,
        isRequired: null,
        isConflict: null,
        isCustomization: null,
        identityRestrictions: null,
        isPrompt: null,
        defaultOption: null,
        sellingPrice: null,
        costPrice: null,
        materialDensity: null,
        membraneWidth: null,
        isThickness: null,
        materialThickness: null,
        url: null,
        content: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  filters: {
  },
  created () {
    this.buildColumns()
    if (!this.drawer) {
      this.getList()
    }
  },
  computed: {
    /** 与 v-hasPermi="['user:specOption:edit']" 一致，用于行内状态/排序/修改的可编辑控制 */
    canEdit () {
      return auth.hasPermi('user:specOption:edit')
    },
    isSimpleSpec () {
      // 指定规格：仅展示/编辑 ID、名称、成本价
      return String(this.queryParam.specId || '') === '648198583975288832'
    },
    displayColumns () {
      const cols = Array.isArray(this.columns) ? this.columns : []
      if (this.isSimpleSpec) {
        const allow = new Set(['id', 'name', 'costPrice', 'operation'])
        return cols
          .filter(c => c && allow.has(c.dataIndex))
          .map(c => {
            if (c.dataIndex === 'costPrice') {
              return { ...c, title: this.$t('views.spec.form.valueLabel') }
            }
            return c
          })
      }
      return cols.filter(c => {
        if (!c || !c.showKey) return true
        if (c.showKey === 'calc') return !!this.showCalc
        if (c.showKey === 'density') return !!this.showDensity
        if (c.showKey === 'manuscriptFee') return !!this.showManuscriptFee
        return true
      })
    }
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    },
    'queryParam.specId': {
      handler (val) {
        if (this.drawer) return
        if (!val) {
          this.showCalc = false
          this.showDensity = false
          this.showManuscriptFee = false
          return
        }
        this.loadSpecMeta(val)
      }
    }
  },
  methods: {
    buildColumns () {
      const t = k => this.$t(k)
      this.columns = [
        { title: t('views.specOption.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.name'), dataIndex: 'name', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.nameEn'), dataIndex: 'nameEn', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.isConflict'), dataIndex: 'isConflict', scopedSlots: { customRender: 'isConflict' }, ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.remark'), dataIndex: 'remark', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.isPrompt'), dataIndex: 'isPrompt', scopedSlots: { customRender: 'isPrompt' }, ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.url'), dataIndex: 'url', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.content'), dataIndex: 'content', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.sellingPrice'), dataIndex: 'sellingPrice', showKey: 'calc', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.costPrice'), dataIndex: 'costPrice', showKey: 'calc', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.manuscriptFee'), dataIndex: 'manuscriptFee', showKey: 'manuscriptFee', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.materialDensity'), dataIndex: 'materialDensity', showKey: 'density', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.membraneWidth'), dataIndex: 'membraneWidth', showKey: 'density', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.isThickness'), dataIndex: 'isThickness', scopedSlots: { customRender: 'isThickness' }, showKey: 'density', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.materialThickness'), dataIndex: 'materialThickness', showKey: 'density', ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.sort'), dataIndex: 'sort', scopedSlots: { customRender: 'sort' }, ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.status'), dataIndex: 'status', scopedSlots: { customRender: 'status' }, ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.createTime'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, ellipsis: true, align: 'center' },
        { title: t('views.specOption.column.operation'), dataIndex: 'operation', width: 200, fixed: 'right', scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
    },
    paginationShowTotal (total) {
      return this.$t('views.specOption.pagination.total', { total })
    },
    loadSpecMeta (specId) {
      const id = specId
      if (!id) {
        this.showCalc = false
        this.showDensity = false
        this.showManuscriptFee = false
        this.specIsCalculation = 0
        return Promise.resolve()
      }
      return getSpec({ id: id }).then(res => {
        const data = (res && res.data) || {}
        const calc = data.isCalculation === true ? 1 : (data.isCalculation === false ? 0 : Number(data.isCalculation))
        this.specIsCalculation = Number.isNaN(calc) ? 0 : calc
        this.showCalc = this.specIsCalculation === 1
        this.showDensity = Number(data.isDensity) === 1
        this.showManuscriptFee = String(id) === '647809383333597184'
      }).catch(() => {
        this.showCalc = false
        this.showDensity = false
        this.showManuscriptFee = false
        this.specIsCalculation = 0
      })
    },
    formatYesNo (value) {
      if (value === null || value === undefined || value === '') return ''
      const v = Number(value)
      if (v === 1) return this.$t('views.specOption.format.yes')
      if (v === 0) return this.$t('views.specOption.format.no')
      return String(value)
    },
    formatPrompt (value) {
      if (value === null || value === undefined || value === '') return ''
      const v = Number(value)
      if (v === 1) return this.$t('views.specOption.format.promptOn')
      if (v === 0) return this.$t('views.specOption.format.promptOff')
      return String(value)
    },
    openDrawer (specId) {
      this.open = true
      if (specId !== undefined && specId !== null && specId !== '') {
        this.queryParam.specId = specId
      }
      this.loadSpecMeta(specId)
      this.queryParam.pageNum = 1
      this.getList()
    },
    onClose () {
      this.open = false
      this.$emit('close')
    },
    /** 查询规格选项树（支持无限层级）列表 */
    getList () {
      this.loading = true
     pageSpecOption(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      if (!this.drawer) {
        this.loadSpecMeta(this.queryParam.specId)
      }
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      // 抽屉内来自某条规格，重置时仅清空搜索条件，保留 specId 过滤
      const fixedSpecId = this.drawer ? this.queryParam.specId : undefined
      this.queryParam = {
        specId: fixedSpecId,
        name: undefined,
        parentId: undefined,
        isCalculation: undefined,
        type: undefined,
        isRequired: undefined,
        isConflict: undefined,
        isCustomization: undefined,
        identityRestrictions: undefined,
        isPrompt: undefined,
        defaultOption: undefined,
        sellingPrice: undefined,
        costPrice: undefined,
        materialDensity: undefined,
        membraneWidth: undefined,
        isThickness: undefined,
        materialThickness: undefined,
        url: undefined,
        content: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('views.specOption.confirm.deleteTitle'),
        content: this.$t('views.specOption.confirm.deleteContent', { ids: String(ids) }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delSpecOption(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.specOption.msg.deleteOk'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.specOption.confirm.exportTitle'),
        content: this.$t('views.specOption.confirm.exportContent'),
        onOk () {
          that.download('user/spec-option/export', {
            ...that.queryParam
          }, `${that.$t('views.specOption.export.filenamePrefix')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 状态开关变更 */
    handleStatusChange (record, checked) {
      if (!this.canEdit) {
        return
      }
      const statusValue = checked ? 1 : 0
      updateSpecOptionStatus({ id: record.id, status: statusValue }).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.specOption.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.specOption.msg.statusFail'))
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (!this.canEdit) {
        return
      }
      if (value === null || value === undefined) {
        return
      }
      updateSpecOptionSort({ id: record.id, sort: value }).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.specOption.msg.sortOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.specOption.msg.sortFail'))
      })
    }
  }
}
</script>
